var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.image)?_c('block-image',{attrs:{"image":_vm.data.image,"background-color":_vm.blockColor}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }